import $ from 'jquery';

export default (selector, activeClass) => {
    const jqTabs = $(selector);
    const jqToggles = jqTabs.find('ul > li, .tab');

    return jqTabs.on('click', 'a', function handleClick(event) {
        event.preventDefault();
        jqToggles.removeClass(activeClass);
        $(this.hash).addClass(activeClass);
        $(this).parent('li').addClass(activeClass);
    });
};
